"use strict";
import { NavLink } from "react-router-dom";
import { Flex, Text, styled } from "ui/src";
import { useSecondaryDestinations } from "components/NavBar/CompanyMenu/Content";
import { TOPAZ_AUDIT_URL, TOPAZ_SOCIAL_URLS } from "constants/socials";
const FooterLink = styled(Text, {
  variant: "body4",
  color: "$neutral3",
  cursor: "pointer",
  animation: "fast",
  hoverStyle: { color: "$neutral1" },
  variants: {
    active: {
      true: { color: "$neutral1" }
    }
  }
});
const LinkReset = { textDecoration: "none" };
function Divider() {
  return <Text variant="body4" color="$neutral3" opacity={0.4} $sm={{ display: "none" }}>
      |
    </Text>;
}
const EXTERNAL_LINK_PROPS = { target: "_blank", rel: "noopener noreferrer", style: LinkReset };
export function Footer() {
  const links = useSecondaryDestinations();
  return <Flex
    width="100%"
    maxWidth={1200}
    mx="auto"
    px="$spacing40"
    py="$spacing24"
    gap="$spacing12"
    $xl={{ px: "$spacing12" }}
  >
      <Flex height={1} backgroundColor="$surface3" />
      <Flex
    row
    alignItems="center"
    justifyContent="space-between"
    gap="$spacing16"
    flexWrap="wrap"
    $md={{ flexDirection: "column", alignItems: "flex-start" }}
  >
        <Flex row alignItems="center" gap="$spacing12" flexWrap="wrap">
          {links.map(
    (link) => link.target ? <a key={link.href} href={link.href} {...EXTERNAL_LINK_PROPS}>
                <FooterLink>{link.title}</FooterLink>
              </a> : <NavLink key={link.href} to={link.href} style={LinkReset}>
                <FooterLink active={link.isActive}>{link.title}</FooterLink>
              </NavLink>
  )}
          <Divider />
          <a href={TOPAZ_AUDIT_URL} {...EXTERNAL_LINK_PROPS}>
            <FooterLink>Audit</FooterLink>
          </a>
        </Flex>

        <Flex row alignItems="center" gap="$spacing12" flexWrap="wrap">
          <a href={TOPAZ_SOCIAL_URLS.x} {...EXTERNAL_LINK_PROPS}>
            <FooterLink>X</FooterLink>
          </a>
          <a href={TOPAZ_SOCIAL_URLS.telegram} {...EXTERNAL_LINK_PROPS}>
            <FooterLink>Telegram</FooterLink>
          </a>
          <a href={TOPAZ_SOCIAL_URLS.github} {...EXTERNAL_LINK_PROPS}>
            <FooterLink>GitHub</FooterLink>
          </a>
          <Divider />
          <Text variant="body4" color="$neutral3">
            Topaz Dex {(/* @__PURE__ */ new Date()).getFullYear()} &copy;
          </Text>
        </Flex>
      </Flex>
    </Flex>;
}
